export default function () {
  /* 表格列头 */
  return [{
    label: "序号",
    type: "index",
    width: 80
  },
  // {
  //   label: "ID",
  //   prop: "id",
  // },
  {
    label: "角色",
    prop: "role_name",
    slots: "role_name",
    minWidth: 100
  },
  {
    label: "账号",
    prop: "username",
    minWidth: 100
  },

  {
    label: "昵称",
    prop: "alias_name",
    width: 150
  },
  {
    label: "手机号",
    prop: "phone_number",
    width: 200
  },
  {
    label: "创建时间",
    prop: "create_time",
    width: 180,
  },
  {
    label: "最近登录时间",
    prop: "last_login_time",
    width: 180,
  },
  {
    label: "操作",
    prop: "operation",
    width: 120,
    slots: "operation",
    fixed: "right",
  },
    // {
    //   label: "createID",
    //   prop: "createID",
    //   slots: "createID",
    //   width: 150
    // },
    // {
    //   label: "登录异常(超过3次冻结)",
    //   prop: "error",
    //   slots: "error",
    //   width: 200,
    // },
    // { label: "密码(已加密)", prop: "password" },
    // {
    //   label: "用户昵称",
    //   prop: "alias_name",
    //   width: 200
    // },
    // { label: "绑定微信openid", prop: "openid", slots: "openid", width: 150 },
    // {
    //   label: "微信绑定",
    //   prop: "saoma",
    //   slots: "saoma",
    //   width: 100,
    // },
    // {
    //   label: "分配门店",
    //   prop: "store_id",
    //   slots: "store_id",
    //   width: 200
    // },
    // {
    //   label: "到期时间",
    //   prop: "vipDate",
    //   width: 200
    // },
  ];
}